import { WhiteLabelTheme } from '../types';

import CardBackground from './assets/cardBackground.svg';
import DashboardIllustration from './assets/dashboard-illustration.svg';
import BannerImage from './assets/dashboardBanner.svg';
import ExpressSetupBanner from './assets/expressSetupBanner.svg';
import FullDashboardIllustration from './assets/full-dashboard-illustration.svg';
import InvestmentsBannerRight from './assets/investmentsBannerRight.svg';
import LoginBackground from './assets/loginBackground.svg';
import LogoIcon from './assets/logo.svg';
import SmallLogoIcon from './assets/minify-logo.svg';
import QrCodeLogo from './assets/qrCodeLogo.svg';
import ReimburseMeSidebar from './assets/reimburseMeSidebar.svg';
import VerificationBackground from './assets/verificationBackground.svg';

const baseColors = {
  onDarkButtonPrimary: '#2E5699',
  onDarkButtonPrimaryHover: '#194691',
  onDarkButtonPrimaryActive: '#16386E',
  onDarkButtonPrimaryPressed: '#16386E',
  onDarkButtonPrimaryDisabled: '#243656',

  onDarkButtonSecondaryHoverBorder: '#2E5699',
  onDarkButtonSecondaryActiveBorder: '#365890',
  onDarkButtonSecondaryDisabledBorder: '#2B3E60',
  onDarkButtonSecondaryDisabled: '#152641',
  onDarkButtonSecondaryHover: '#253D63',

  onDarkModuleBackground: '#203453',
  onDarkBackground: '#152641',

  buttonPrimary: '#12284B',
  buttonPrimaryHover: '#344663',
  buttonPrimaryActive: '#213452',
  buttonPrimaryPressed: '#344663',
  buttonPrimaryDisabled: '#E5E9F0',

  buttonSecondaryHoverBorder: '#637775',
  buttonSecondaryActiveBorder: '#91A4A2',
  buttonSecondaryDisabledBorder: '#E5E9F0',
  buttonSecondaryDisabled: '#FFFFFF',
  buttonSecondaryHover: '#DEF2F0',

  buttonTertiaryHover: '#DEF2F0',
  buttonTertiaryPressed: '#CCDEDC',
  buttonTertiaryDisabled: '#E5E9F0',
  buttonSecondaryContainer: '#E5E9F0',

  textTitle: '#0F1621',
  textBody: '#0F1621',
  textSecondary: '#63656A',
  textDisabled: '#9BA3B3',
  textOnColor: '#FFFFFF',
  textAccent: '#12284B',
  textAccentHover: '#344663',
  textAccentActive: '#213452',
  buttonText: '#FFFFFF',

  iconPrimary: '#0F1621',
  iconSecondary: '#63656A',
  iconOnColor: '#FFFFFF',
  iconAccent: '#12284B',
  iconAccentHover: '#344663',
  iconAccentActive: '#213452',
  iconDisabled: '#9BA3B3',

  background1: '#12284B',
  background2: '#0F1621',
  background3: '#000000',
  border: '#B8BFCC',
  border1: '#E5E9F0',
  border2: '#EEF1F4',
  module: '#F7F8F9',
  canvas: '#FFFFFF',
  legend: '#9BA3B3',
  accentActive: '#12284B',
  accentBorder: '#7EA7E9',
  accentContainer: '#BED3F4',
  textHighlighter: '#FFFF80',

  success: '#5DAC37',
  successBorder: '#A0D288',
  successContainer: '#EEFCE8',

  warning: '#E8B842',
  warningBorder: '#F9D271',
  warningContainer: '#FFEDC1',

  danger: '#E23131',
  dangerBorder: '#EE6B6B',
  dangerContainer: '#FFF3F3',
  dangerHover: '#A61C18',
  dangerActive: '#66120A',

  info: '#425CE2',
  infoBorder: '#768CFF',
  infoContainer: '#CED6FF',

  transactionMedical: '#00C3B3',
  transactionDental: '#176AF6',
  transactionVision: '#481A54',
  transactionOther: '#FF9D0A',
  transactionParking: '#323D9B',
  transactionTransit: '#9BBF84',
  transactionAdoption: '#0F7970',
  transactionDependentCare: '#CC3381',
  transactionPharmacy: '#D83B00',
  transactionLifestyle: '#D3375C',
  transactionPremium: '#3628D1',
  transactionTravel: '#F26B31',
  transactionWellness: '#9B31F2',
  transactionPlanSpecific: '#00B5EE',
  refund: '#588C0E',
  transactionDefault: '#5E697E',
  claimTransferInternal: '#E5E9F0',
  nonClaimIcon: '#151F6D',
  nonClaimBg: '#E5E9F0',

  planTypeHSA: '#2EA12B',
  planTypeHCFSA: '#FA802A',
  planTypeDCAP: '#CC3381',
  planTypeHRA: '#134E8F',
  planTypeCommuterTransit: '#9BBF84',
  planTypeCommuterParking: '#323D9B',
  planTypeAdoption: '#0F7970',
  planTypeLifestyle: '#D3375C',
  planTypeSpecialty: '#00B5EE',
  planTypeTravel: '#F26B31',
  planTypeRx: '#7909AD',
  planTypeDental: '#176AF6',
  planTypeVision: '#481A54',
  planTypeMedical: '#00C3B3',

  lockedNull: '#000000',
  processingPending: '#F9C134',
  needsHelp: '#FF9D0A',
  paidActiveComplete: '#19B269',
  partiallyPaid: '#B9CC29',
  waitingForFunds: '#8EB2A1',
  deniedErrorExpired: '#E72626',
  uploading: '#9BA3B3',
  uploadedApproved: '#176AF6',
  loa: '#00B5EE',
  retirement: '#CE8258',
  future: '#7909AD',

  missingDetail: '#FB6D2A',
  missingContainer: '#FFF3EE',
  missingBorder: '#FEDACA',

  investmentsProfit: '#00FF93',
  investmentsLoss: '#EF235D',
  investmentsfuture: '#7909AD',
  investmentsFund1: '#00C3B3',
  investmentsFund2: '#481A54',
  investmentsFund3: '#D83B00',
  investmentsFund4: '#176AF6',
  investmentsFund5: '#FF9D0A',
  investmentsFund6: '#078F84',
  investmentsFund7: '#323D9B',
  investmentsFund8: '#F3C626',
  investmentsFund9: '#A528C6',
  investmentsFund10: '#0C95D0',
  investmentsFund11: '#619C00',
  investmentsFund12: '#CC3381',

  partner: '#D83B00',
  distributor: '#904D27',
  employer: '#174FBC',
  subsidiary: '#0F7970',
  subgroup: '#481A54',
  claimProcessor: '#176AF6',
  employee: '#0CAD09',
  dependent: '#5E1696',
  noAssignee: '#B8BFCC',

  claimParticipant: '#CC3381',
  claimSystem: '#18A0FB',
  claimCardProcessor: '#19B269',

  popup: 'rgba(15, 22, 33, 0.5)',
  popup2: 'rgba(15, 22, 33, 0.05)',
  fade1: 'linear-gradient(0deg, #F7F9FA 0%, rgba(255, 255, 255, 0.00) 100%)',
  fade2: 'linear-gradient(180deg, #F7F9FA 0%, #EEF1F4 100%)',
};

const navigationColors = {
  navigationBackground: '#F7F8F9',
  navigationBorder: '#E8E8E8',
  navigationAccent: '#12284B',
  navigationAccent2: '#12284B',
  navigationTextDefault: '#0F1621',
  navigationTextAccent: '#E0CC00',
  navigationIconDefault: '#0F1621',
  navigationIconAccent: '#E0CC00',
  navigationAccentHover: '#D0DCDB',
  navigationAccentActive: '#12284B',
};

export default {
  title: 'Admin Apprize',
  colors: {
    ...baseColors,
    ...navigationColors,

    loginTitleColor: baseColors.textBody,
  },
  logo: LogoIcon,
  minifyLogo: SmallLogoIcon,
  font: "'GothamRounded'", // Also you need add font import to global.scss example: @import url('https://fonts.googleapis.com/css2?family=PT+Serif:ital,wght@0,400;0,700;1,400;1,700&display=swap');
  titleFont: "'GothamRounded'",
  images: {
    banner: BannerImage,
    investmentsBannerRight: InvestmentsBannerRight,
    cardBackground: CardBackground,
    reimburseMeSidebar: ReimburseMeSidebar,
    lgLoginBackground: LoginBackground,
    verificationBackground: VerificationBackground,
    qrCodeLogo: QrCodeLogo,
    expressSetupBannerBackground: ExpressSetupBanner,

    fullDashboardIllustration: FullDashboardIllustration,
    dashboardIllustration: DashboardIllustration,
  },
  fonts: {
    sidebarWeight: 700,
    reimbursementWeight: 500,
    sizes: {
      small: {
        size: '12px',
        height: '16px',
        maxWidth: '336px',
      },
      '3xl': {
        size: '30px',
        height: '40px',
        maxWidth: '1008px',
      },
      '2xl': {
        size: '24px',
        height: '30px',
        maxWidth: '816px',
      },
    },
  },
  rounds: {
    largeRound: '0px',
    moduleRound: '0px',
    container1Round: '0px',
    container2Round: '0px',
    checkboxRound: '0px',
    fieldRound: '0px',
    button1Round: '0px',
    button2Round: '0px',
    dropdownItemRound: '0px',
    snackbarRound: '0px',
    smallRound: '0px',
  },
  shadows: {
    default: '0px 1px 7px rgba(0, 0, 0, 0.04);',
    hover: '0px 2px 13px rgba(0, 0, 0, 0.10);',
    active: '0px 8px 25px rgba(0, 0, 0, 0.25);',
    highlighted: '0px 6px 16px rgba(18, 40, 75, 0.45);',
  },
  favicon: '/apprize/favicon.ico',
  favicon16: '/apprize/favicon-16x16.png',
  favicon32: '/apprize/favicon-32x32.png',
  faviconAppleTouch: '/apprize/apple-touch-icon-fidelity.png',
} as WhiteLabelTheme;
